import { Component, OnInit ,Input} from '@angular/core';
import { Datipreventivo } from '../model/datipreventivo';
import { FormGroup,FormControl,Validators,FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-preventivo-dati-anagrafici',
  templateUrl: './preventivo-dati-anagrafici.component.html',
  styleUrls: ['./preventivo-dati-anagrafici.component.scss']
})
export class PreventivoDatiAnagraficiComponent implements OnInit {

  @Input() dati:Datipreventivo
  @Input() touchedform: boolean;

  validatingForm:FormGroup;

  constructor( private fb: FormBuilder) { }

  ngOnInit() {
    this.validatingForm = this.fb.group({

      'nome': new FormControl(this.dati.lead.nome, [Validators.required]),
      'cognome': new FormControl(this.dati.lead.cognome, [Validators.required]),
      'email': new FormControl(this.dati.lead.email, [Validators.pattern('^$|^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$')]),
      'cap': new FormControl(this.dati.lead.cap, [Validators.required]),
      'telefono': new FormControl(this.dati.lead.telefono, [Validators.required]),
      'privacy': new FormControl(this.dati.lead.privacy1, [Validators.requiredTrue]),
      'termini': new FormControl(this.dati.lead.privacy2, [Validators.requiredTrue])

    });

    // this.validatingForm = this.fb.group({

    //   'nome': new FormControl(this.dati.lead.nome, [Validators.required]),
    //   'cognome': new FormControl(this.dati.lead.cognome, [Validators.required]),
    //   'email': new FormControl(this.dati.lead.email, [Validators.required, Validators.email]),
    //   'cap': new FormControl(this.dati.lead.cap, [Validators.required]),
    //   'telefono': new FormControl(this.dati.lead.telefono, [Validators.required]),
    //   'privacy': new FormControl(this.dati.lead.privacy1, [Validators.requiredTrue]),
    //   'termini': new FormControl(this.dati.lead.privacy2, [Validators.requiredTrue])

    // });
  }

}




// WEBPACK FOOTER //
// ./src/app/preventivo-dati-anagrafici/preventivo-dati-anagrafici.component.ts